function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
export class EraserTool extends WhiteboardTool {
  constructor(enableToolEvent, renderableModel, shadowEmitter, scope, trashedElementsModel, shadowScope) {
    super(enableToolEvent, renderableModel, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "trashedElementsModel", void 0);
    _defineProperty(this, "pointCount", 0);
    _defineProperty(this, "showLiveCursor", true);
    _defineProperty(this, "shadowScope", void 0);
    this.trashedElementsModel = trashedElementsModel;
    this.tool.minDistance = 2;
    this.shadowScope = shadowScope;
  }
  onMouseDown(_event) {
    this.pointCount = 0;
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createEraser();
      }
    });
  }
  onMouseDrag(event) {
    if (this.pointCount > 1024) {
      return;
    }
    if (this.elementModel) {
      this.pointCount += 1;
      this.elementModel.appendPoints([event.point.x, event.point.y]);
    }
    this.scope.project.activeLayer.children.forEach(item => {
      if (item.data.role === 'background') {
        return;
      }
      if (item.data.type && ['selector', 'eraser', 'laser'].indexOf(item.data.type) < 0 && item.hitTest(event.point, {
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 5
      })) {
        this.trashedElementsModel.addTrashedElementForSelf(item.data.uuid, item.data.ownerId);
      }
    });
    this.shadowScope.project.activeLayer.children.forEach(item => {
      if (item.data.role === 'background') {
        return;
      }
      if (item.data.type && ['selector', 'eraser', 'laser'].indexOf(item.data.type) < 0 && item.hitTest(event.point, {
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 5
      })) {
        this.trashedElementsModel.addTrashedElementForSelf(item.data.uuid, item.data.ownerId);
      }
    });
  }
  onMouseUp(_event) {
    if (this.elementModel) {
      this.modelGetter().then(model => {
        if (model && this.elementModel) {
          model.removeElementItem(this.elementModel.uuid);
        }
      });
    }
    this.trashedElementsModel.removeAllTrashedElementsForSelf();
  }
}